import { render, staticRenderFns } from "./set-weight-modal.vue?vue&type=template&id=2f9e9334&scoped=true&"
import script from "./set-weight-modal.vue?vue&type=script&lang=js&"
export * from "./set-weight-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e9334",
  null
  
)

export default component.exports